import { MenuItem } from '@material-ui/core';
import React from 'react';

import useRoles from 'core/hooks/useRoles';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function RoleSelect(props: InputFieldProps) {
  const roles = useRoles();

  return (
    <InputField
      {...props}
      select
      fullWidth
      variant="outlined"
      placeholder="Valitse"
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
    >
      {roles.map(role => (
        <MenuItem key={role.id} value={role.id}>
          {role.label}
        </MenuItem>
      ))}
    </InputField>
  );
}
